import { render, staticRenderFns } from "./TheFacilitiesKeyCopyList.vue?vue&type=template&id=24aa6b20&"
import script from "./TheFacilitiesKeyCopyList.vue?vue&type=script&lang=js&"
export * from "./TheFacilitiesKeyCopyList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports